<template>
  <div class="play">
    <div v-if="err">{{errMsg}}</div>
    <div v-show="!showLoading && !err">
      <div class="home">
        <router-link tag="span" to="/index"><i class="iconfont icon-home"></i>返回首页</router-link>
        <a href="https://www.wjx.top/jq/30293001.aspx" class="zixun"><i class="iconfont icon-winfo-icon-fankuiwenti"></i>问题反馈</a>
      </div>
      <div class="player-wrapper" ref="player">
        <div ref="player" v-show="showVideo">
          <video ref="video" controls id="player" preload="none" webkit-playsinline="" playsinline="" x5-playsinline style="display: inline;height: 100%; width: 100%;">
            <source src="" type="video/mp4">
          </video>
          <!--<div class="tip-time" v-if="timeTip">试看时长{{parseInt(videoInfo.seetime/60)}}分钟, 视频总时长{{videoInfo.video_duration}}分钟</div>-->
          <div class="tip-time" v-if="timeTip">点击试看</div>
        </div>
        <div class="no-access" v-if="!showVideo" :style="'background-image: url('+videoInfo.thumb+');'">“立即购买”即可解锁课程</div>
        <div class="audio-poster" ref="audioPoster"></div>
      </div>
      <!-- 折扣一口价倒计时 vip就忽略这个促销信息 -->
      <free-countdown v-if="!user.isvip&&(videoInfo.promotion_type === 2 || videoInfo.promotion_type === 3)" :end="videoInfo.promotion_enddate"></free-countdown>
      <!-- 标题栏 -->
      <div class="big-title-wrap">
        <div class="big-title">
          <p><span v-if="videoInfo.istop">精品课</span>{{videoInfo.title}}</p>
          <div class="price">
            <!-- 没有购买 -->
            <template v-if="!videoInfo.is_buy">
              <!-- vip了 显示vip打折图标 体系课才有的 -->
              <img src="~common/image/vip-label-1.png" alt="" class="vip-label-1" v-if="user.isvip && videoInfo.type === 2">
              <!-- 打折或者 一口价 -->
              <template v-if="videoInfo.promotion_type === 2 || videoInfo.promotion_type === 3 || videoInfo.promotion_type === 4">
                <!-- 促销就用促销价格 -->
                <span class="n">￥{{videoInfo.promotion_price}}</span>
                <s class="o">￥{{videoInfo.price}}</s>
              </template>
              <!-- 限时免费 -->
              <template v-else-if="videoInfo.promotion_type === 1">
                <span class="f">限时免费</span>
                <s class="o">￥{{videoInfo.price}}</s>
              </template>
              <!-- 没有活动 显示原价 -->
              <template v-else>
                <span class="n">￥{{videoInfo.price}}</span>
              </template>
            </template>
            <!-- 已购买就显示学了多久了 -->
            <template v-else>
              <!-- vip了 显示vip图标 微课才有-->
              <img src="~common/image/vip-label.png" alt="" class="vip-label" v-if="user.isvip&&videoInfo.type===1">
              <span class="b" v-if="!videoInfo.is_complete">已学习{{videoInfo.study_time}}分钟</span>
              <span class="b" v-else>已完成学习</span>
            </template>
            <!-- 右侧的赞 -->
            <!-- <span class="zan" :class="{active: videoInfo.is_like}" @click="_zanVideo"><i class="iconfont icon-zan"></i> {{videoInfo.goods||0}}</span> -->
            <span class="zan">评分 {{videoInfo.stars}}</span>
          </div>
        </div>
        <!-- 助力活动 是vip就不显示 -->
        <zhuli :zhuliData="zhuliData" :kcData="videoInfo" v-if="videoInfo.is_assistance === 1 && !user.isvip"></zhuli>
        <get-vip v-else-if="!user.isvip&&!videoInfo.is_buy"></get-vip><!-- 没有助力 且不是 vip 并且没有买 提醒去开通vip-->
      </div>
      <con-tab class="nav-tab border-bottom">
        <template>
          <!-- <router-link tag="div" to="kcjs" class="tab" replace >
            <span>课程介绍</span>
          </router-link> -->
          <router-link tag="div" to="twxq" class="tab" replace >
            <span>课程详情</span>
          </router-link>
          <router-link tag="div" to="related" class="tab" replace >
            <span>相关课程</span>
          </router-link>
        </template>
      </con-tab>
      <!-- <div class="nav2">
        <div class="col col-1">{{title}}</div>
        <div class="col col-2">
          <span class="active"><i class="shang" @click="dashangDialog=true">赏</i> {{videoInfo.rewards_num||0}}</span>
          <span :class="{active: videoInfo.is_like}" @click="_zanVideo"><i class="iconfont icon-zan"></i> {{videoInfo.goods||0}}</span>
          <span @click="toPinglun"><i class="iconfont icon-pinglun1"></i></span>
        </div>
      </div> -->
      <div class="list">
        <keep-alive>
          <router-view @setTitle="setTitle" @appendComment="appendComment" @controlVideo="controlVideo" :kcjsContent="videoInfo.description" :twxqContent="videoInfo.content" :videoId="videoId" :courseId="courseId" :bought="bought" :teacher="videoInfo.teacher" :shang="videoInfo.reward_list" :shangNum="videoInfo.reward_total"></router-view>
        </keep-alive>
      </div>
      <div class="buy">
        <div>
          <!--<div class="buy" v-if="false">-->
          <div class="col col-1" @click="collect">
            <i class="iconfont" :class="{'icon-shoucang':!videoInfo.is_collection,'icon-yishoucang':videoInfo.is_collection}"></i>
            收藏
            <!-- <template v-if="!videoInfo.is_promotion">价格: ¥{{videoInfo.price}}</template>
            <template v-if="videoInfo.is_promotion"><s>价格: {{videoInfo.price}}</s>&emsp;<span>¥{{videoInfo.promotion_price}}</span></template> -->
          </div>
          <template v-if="bought">
            <!-- 完成学习了 可以查看证书 -->
            <div class="col col-2" v-if="videoInfo.is_complete&&videoInfo.cert" @click="goCert(videoInfo.cert)">查看证书</div>
            <div class="col col-2" v-else-if="videoInfo.is_complete">已完成学习</div>
            <div class="col col-2 disabled" v-else>未完成学习</div>
          </template>
          <div class="col col-2" @click="buy" v-else>立即购买</div>
        </div>
      </div>
      <!-- 打赏 暂时没有用了 -->
      <div class="dashang-dialog-wrap" v-if="dashangDialog">
        <div class="mask"></div>
        <div class="content">
          <div class="title">打赏</div>
          <div class="input-wrap">
            <input type="number" placeholder="打赏金额" v-model="amount">元
          </div>
          <div class="btns">
            <div class="col col-1" @click="dashang">确定</div>
            <div class="col col-1" @click="dashangDialog=false">取消</div>
          </div>
        </div>
      </div>
      <!-- 分销按钮 -->
      <div class="zhuan" v-if="isWeixin">
        <div>
          <router-link tag="div" :to="{name: 'fenxiao', params: {url: url, courseId: courseId, courseTitle: videoInfo.title}}" v-if="videoInfo.is_distribution">
            <div class="col col-1">
              <i class="iconfont icon-renminbi"></i>
            </div>
            <div class="col col-2">
              <span>赚<span v-if="videoInfo.show_share_price">{{videoInfo.share_price}}元</span></span>
            </div>
          </router-link>
        </div>
      </div>
      <!-- 试听结束购买 -->
      <div class="ended-dialog-wrap" v-show="showShiTingDialog">
        <div class="mask"></div>
        <div class="content">
          <div class="title">{{buyMsg}}</div>
          <div class="btns">
            <div class="col col-1" @click="buy">立即购买</div>
            <div class="col col-1" @click="showShiTingDialog=false">取消</div>
          </div>
        </div>
      </div>
      <!-- 试听结束观看下一节 -->
      <div class="ended-dialog-wrap" v-show="showXYJDialog">
        <div class="mask"></div>
        <div class="content">
          <div class="title">当前试听已结束,是否观看下一节</div>
          <div class="btns">
            <router-link tag="div" :to="'/play/' + videoInfo.course_id+ '/' + videoInfo.next_video_id" replace class="col col-1">确定</router-link>
            <div class="col col-1" @click="showXYJDialog=false">取消</div>
          </div>
        </div>
      </div>
      <!-- 评论 暂时没有用了 -->
      <div class="pl-dialog-wrap" v-show="showCommentDialog" v-if="false">
        <div class="mask"></div>
        <div class="content">
          <div class="title">评论</div>
          <div class="input-wrap">
            <textarea placeholder="请输入内容, 内容限制在140字符以内" v-model="commentContent" @blur="controlVideo('show')"></textarea>
          </div>
          <div class="btns">
            <div class="col col-1" @click="_submitComment">提交</div>
            <div class="col col-1" @click="commentCancel">取消</div>
          </div>
        </div>
      </div>
    </div>
    <loading v-show="showLoading"></loading>
    <qr-popup class="qr-popup" :show="showQrPopup" :img="qrurl" :text="qrtext"></qr-popup>
  </div>
</template>
<script type="text/ecmascript-6">
/* eslint-disable */
import config from '@/utils/config.js'
// import Loading from '../base/loading/loading2'
import {RES_OK} from '@/api/config'
import {getVideoInfo, browseTimeLog, submitComment, browsePageLog} from '../../api/play.js'
import {zanVideo, videoPageShare, ChannelHaoYou, ChannelPengYouQuan} from '@/api/user-behavior.js'
import Loading from '../base/loading/loading.vue'
import 'mediaelement'
import 'mediaelement/build/mediaelementplayer.min.css'
import 'mediaelement-plugins/dist/jump-forward/jump-forward.js'
import 'mediaelement-plugins/dist/skip-back/skip-back.js'
import 'mediaelement-plugins/dist/jump-forward/jump-forward.css'
import 'mediaelement-plugins/dist/skip-back/skip-back.css'
import {wxShare, currentHref, zhuliShareConfig} from '../../api/wx-share.js'
import 'weixin-js-sdk'
import {mapGetters} from 'vuex'
import Zhuli from 'components/base/activity/zhuli/zhuli'
import {getZhuli} from '@/api/activity/zhuli.js'
import {collectCourse} from '@/api/user-behavior'
import FreeCountdown from 'components/base/ui/free-countdown'
import ConTab from 'components/base/ui/course-tab'
import GetVip from 'components/base/ui/get-vip'
import QrPopup from 'components/base/qr-popup'
import { duration } from '../../store/getters'
/* eslint-disable */
export default {
  data() {
    return {
      title: '',
      videoInfo: {},
      courseId: this.$route.params.id,
      videoId: this.$route.params.video_id,
      dashangDialog: false,  //打赏弹窗
      amount: 1, // 打赏金额
      url: currentHref(),
      showLoading: true,
      err: false,
      errMsg: '发生错误',
      showVideo: false,
      // 是否显示购买试听对话框
      showShiTingDialog: false,
      // 是否显示播放下一节对话框
      showXYJDialog: false,
      // 历史播放时间
      historyTime: 0,
      // 本次有效播放时长统计
      duration:0,
      // 分享ID
      shareId: sessionStorage.getItem('share_id') || '',
      // 分享的课程ID
      shareGoodsId: sessionStorage.getItem('share_goods_id') || '',
      // 评论内容
      commentContent: '',
      showCommentDialog: false,
      commentList: [],
      // 是否购买
      bought: false,
      // 提示购买信息
      buyMsg: '',
      // 链接来源
      fromLinkId: this.$route.query.linkId,
      // 讲师ID
      teacherId: this.$route.query.teacher,
      timeTip: false,
      // 助力活动
      zhuliData: {},
      // 收藏请求中，防止用户快速点击这个按钮
      collecting: false,
      // 收藏课程操作二维码弹框
      showQrPopup: false,
      qrurl: '',
      qrtext: ''
    }
  },
  computed: {
    ...mapGetters({
      isWeixin: 'isWeixin'
    }),
    ...mapGetters(['user'])
  },
  created() {
    // this._getVideoInfo()
  },
  mounted() {
    this._getVideoInfo()
    // 从localstorage中获取播放时间
    this.historyTime = localStorage.getItem('playerCurrentTime-'+this.courseId+'-'+this.videoId) || 0
    this.duration = 0
    // this._browseTimeLog()
  },
  methods: {
    // 助力活动
    _getZhuli(aaid) {
      // 获取活动信息
      getZhuli(this.videoInfo.course_id, this.videoInfo.activity_id, aaid).then(res => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.zhuliData = data.data
        } else {
          let msg = data.msg || '系统异常'
          this.$toast(msg, {
            duration: 3500
          })
        }
      }).catch(err => {
        this.$toast(err.response.data.msg, {
          duration: 3500
        })
        // alert(err.response.data.msg)
      })
    },
    player(successCallback) {
      return new MediaElementPlayer('player', {
        stretching: 'auto',
        pluginPath: 'mediaelement/build/',
        features: ['playpause', 'skipback', 'current', 'progress', 'duration', 'jumpforward', 'fullscreen'],
        skipBackInterval: 10,
        jumpForwardInterval: 10,
        autoRewind: false,
        useFakeFullscreen: false, // 是否使用伪全屏
        clickToPlayPause: true, // 启用点击视频元素切换播放/暂停
        stretching: 'fill',
        success: (media, node, instance) => {
          successCallback(media, node, instance)
        },
        error: (media, node) => {
          alert('视频播放错误')
          console.log(node.error)
        }
      })
    },
    // 设置子title
    setTitle(title) {
      this.title = title
    },
    _getVideoInfo() {
      getVideoInfo(this.courseId, this.videoId).then((res) => {
        // console.log('请求完成')
        // console.log(res.data.code)
        let data = res.data
        // console.log('视频信息', data)
        if (data.code === RES_OK) {
          this.videoInfo = (data.data)
          // 设置title
          document.title = this.videoInfo.title
          // 微信分享
          wxShare({success: () => {
            videoPageShare(this.courseId, this.videoId, ChannelHaoYou)
          }}, {success: () => {
            videoPageShare(this.courseId, this.videoId, ChannelPengYouQuan)
          }})
          // 助力活动
          // 获取助力活动参数
          let aaid = this.$route.query.aaid
          console.log(this.videoInfo.is_assistance)
          // 如果是助力活动, 获取助力活动信息
          if (this.videoInfo.is_assistance === 1 && aaid) {
            // 修改分享信息
            wxShare(zhuliShareConfig(this.videoInfo.numlimit))
            // 获取助力活动信息
            this._getZhuli(aaid)
          }
          // alert(this.videoInfo.last_url)
          this.showLoading = false

          // 判断是不是免费课程
          if (this.videoInfo.islimitfree === 1 || this.videoInfo.is_buy) {
            this.bought = true
          }
          if (this.videoInfo.last_url) {
            // 显示视频
            this.showVideo = true
            // 设置视频地址
            // this.$refs.video.src = this.videoInfo.last_url
            // 如果是视频才设置视频图片
            this.$refs.video.poster = this.videoInfo.thumb
            this.player((media, node, instance) => {
              // 判断是不是试听课程, 如果是, 显示试听时长
              if (!this.videoInfo.is_buy && parseFloat(this.videoInfo.price) > 0) {
                this.timeTip = true
              }
              media.src = this.videoInfo.last_url
              // media.src = 'https://video.goloiov.cn/golo-sns/uploads/video/20190117/FqhRVSuf_ShJifPB6PhtwnWTFfEX.mp4?timestamp=1548065120&course_id=1133&video_id=1542&token=6ea01f7a-3687-4d67-afa1-0d10f2bb7121&sign=5f3c540635b9501063d42b9e53316a66'
              // 判断是不是音频文件, 如果是, 隐藏video控件
              if (this.videoInfo.last_url.indexOf('.mp3') !== -1) {
                this.$refs.video.style.display = 'none'
                this.$refs.audioPoster.style.display = 'block'
                this.$refs.audioPoster.style.backgroundImage = 'url(' + this.videoInfo.thumb + ')'
              }
              let timer = null
              // alert(this.historyTime)
              // 自动播放
              // instance.play()
              // alert(222)
              // 如果可以播放, 跳到指定时间播放
              node.addEventListener('loadedmetadata', () => {
                setTimeout(() => {
                  instance.setCurrentTime(this.historyTime)
                }, 1000)
              }, false)
              // 苹果手机旋转屏幕进入全屏
              window.addEventListener('orientationchange', function() {
                if ((window.orientation === 90 || window.orientation === -90) && navigator.userAgent.indexOf('iPhone') > -1) {
                  instance.enterFullScreen()
                }
              }, false)
              // 播放结束
              node.addEventListener('ended', () => {
                // 清除定时器
                clearInterval(timer)
                timer = null
                // 判断课程类型, 如果是微课, 播放结束需要弹出购买弹窗, 如果是体系课, 弹出观看下一节
                if (this.videoInfo.type === 1) {
                  // 判断是不是试听, 如果是试听, 弹出购买
                  // console.log(!this.videoInfo.is_buy, this.videoInfo.pop_is_buy, (!this.videoInfo.is_buy && this.videoInfo.pop_is_buy))
                  if (!this.videoInfo.is_buy && this.videoInfo.pop_is_buy) {
                    this.buyMsg = '当前试听已结束,请购买后继续听课'
                    this.showShiTingDialog = true
                  }
                } else if (this.videoInfo.type === 2) {
                  // 弹出播放下一节
                  if (this.videoInfo.next_video_id !== '') {
                    // console.log('/play/' + this.videoInfo.course_id+ '/' + this.videoInfo.next_video_id + '/kcjs')
                    this.showXYJDialog = true
                  }
                }
                // 播放时间重置
                localStorage.setItem('playerCurrentTime-'+this.courseId+'-'+this.videoId, 0)
              })
              // 开始播放
              node.addEventListener('play', () => {
                this.timeTip = false
                timer = setInterval(() => {
                  this.duration += 1;
                  // console.log('duration: ',this.duration)
                  // console.log('currentTime: ',parseInt(instance.getCurrentTime()))
                  localStorage.setItem('playerCurrentTime-'+this.courseId+'-'+this.videoId, parseInt(instance.getCurrentTime()))
                }, 1000)
              })
              // 暂停
              node.addEventListener('pause', () => {
                // 清除定时器
                clearInterval(timer)
                timer = null
              })
              let exitFullscreenBtn = document.querySelectorAll('.mejs__fullscreen-button')[0]
              exitFullscreenBtn.addEventListener('click', (el) => {
                // console.log(instance)
                // 全屏
                let fullscreen = !(exitFullscreenBtn.className.indexOf('mejs__unfullscreen') === -1)
                // 非全屏
                if (!fullscreen) {
                  // this.$refs.video.style.width = '100%'
                  // this.$refs.video.style.height = '100%'
                  // 退出全屏
                  instance.exitFullScreen()
                  console.log('退出全屏')
                }
              })
            })
          } else {
            console.log(this.videoInfo.last_url)
            // 判断体系课是否购买
            if (this.videoInfo.type == 2 && !this.videoInfo.is_buy && !this.videoInfo.isallow) {
              this.buyMsg = '“立即购买” 即可解锁课程'
              this.showShiTingDialog = true
            }
          }
        } else {
          this.showLoading = false
          this.err = true
          this.errMsg = data.msg
        }
      }).catch(err => {
        document.title = '发生错误'
        console.log('发生错误')
        console.log(err)
        this.showLoading = false
        this.err = true
        this.errMsg = err.response.data.msg || err.response.data
      })
    },
    // 点赞
    _zanVideo() {
      zanVideo(this.courseId, this.videoId).then(res => {
        let data = res.data
        if (data.code === RES_OK) {
          this.videoInfo.is_like = !this.videoInfo.is_like
          if (this.videoInfo.is_like) {
            this.videoInfo.goods++
          } else {
            this.videoInfo.goods--
          }
        }
      })
    },
    // 打赏
    dashang() {
      // 打赏已经移到图文详情中
      let reg = /^[1-9][0-9]*$/
      if (!reg.test(this.amount)) {
        this.$toast('请输入正整数金额')
        return
      } else if (this.amount > 100) {
        this.$toast('最大打赏金额不能大于100元')
        return
      }
      window.location.href = (localStorage.getItem('web_domain') || config.host) + ('index/index/'+(this.isWeixin?'pay':'qrpay')+'/?goods_id=' + this.courseId + '&payment_type=4&video_id=' + this.videoId + '&amount=' + this.amount + '&anchor=' + this.$route.path)
    },
    // 购买课程
    buy() {
      let commonUrl = '?goods_id=' + this.courseId + '&payment_type=1&video_id=' + this.videoId + '&amount=' + this.amount + '&anchor=' + this.$route.path
      let shareUrl = '&share_id=' + this.shareId + '&share_goods_id=' + this.shareGoodsId
      if (this.shareId !== '') {
        commonUrl = commonUrl + shareUrl
      }
      let wxUrl = 'index/index/pay/' + commonUrl
      let h5Url = 'index/index/pay/' + commonUrl + '&payment_platform=MWEB'
      let padUrl = 'index/index/qrpay/' + commonUrl
      // 获取设备类型
      // DEVICE_TYPE: wechat, h5, pad
      const DEVICE_TYPE = localStorage.getItem('device_type')
      let webDomain = localStorage.getItem('web_domain') || config.host
      if (DEVICE_TYPE === 'wechat') {
        window.location.href = webDomain + wxUrl
        console.log(webDomain + wxUrl)
      } else if (DEVICE_TYPE === 'h5') {
        window.location.href = webDomain + h5Url
        console.log(webDomain + h5Url)
      } else if (DEVICE_TYPE === 'pad') {
        window.location.href = webDomain + padUrl
        console.log(webDomain + padUrl)
      }
    },
    // 统计播放时长
    _browseTimeLog() {
      let currTime = parseInt(this.$refs.video.currentTime)
      if (currTime !== 0 || this.duration!==0) {
        browseTimeLog(this.courseId, this.videoId, currTime, this.duration)
      }
    },
    // 跳转评论页面
    toPinglun() {
     if (!this.bought && !this.videoInfo.isallow) {
      this.$toast('请购买课程后评论')
      return
     }
      this.showCommentDialog = true
      this.$router.push({path: 'kcpj'})
      this.controlVideo('hide')
    },
    appendComment(commentList) {
      // console.log('+++commentList', commentList)
      this.commentList = commentList
    },
    _submitComment() {
      if (!this.commentContent) {
        this.$toast('评论内容不能为空')
        return
      }
      if (this.commentContent.length > 140) {
        this.$toast('最大评论字数为140个字符')
        return
      }
      submitComment(this.commentContent, this.courseId, this.videoId).then(res => {
        debugger
        let data = res.data
        if (data.code === RES_OK) {
          this.showCommentDialog = false
          let d = data.data
          d.child = []
          this.commentList.unshift(d)
          this.commentContent = ''
          this.$toast('评论成功', {
            durtaion: 200
          })
        } else {
          this.$toast(data.msg)
        }
      })
    },
    // 控制视频控件显示或隐藏
    controlVideo(showOrHide) {
      // 如果是安卓手机就控制显示隐藏
      if (/android/.test(navigator.userAgent.toLowerCase())) {
        if (showOrHide === 'show') {
          this.$refs.player.style.display = 'block'
        }
        if (showOrHide === 'hide') {
          this.$refs.player.style.display = 'none'
        }
      }
    },
    // 评论取消
    commentCancel() {
      this.showCommentDialog = false
      this.commentContent = ''
      // 显示视频控件
      this.controlVideo('show')
    },
    collect() {
      // 收藏课程
      if (this.collecting) return
      this.collecting = true
      collectCourse(this.courseId, this.videoId).then(res => {
        let data = res.data
        if (data && data.code === RES_OK) {
          if (this.videoInfo.is_collection) {
            this.$toast('取消收藏成功')
            this.showQrPopup = false
          } else {
            this.$toast('收藏成功')
            if (data.data.qrurl) {
              console.log('弹出关注二维码')
              this.qrurl = data.data.qrurl
              this.qrtext = '关注公众号, 新增课程马上知道'
              this.showQrPopup = true
            }
          }
          this.videoInfo.is_collection = !this.videoInfo.is_collection
        } else if (data && data.msg) {
          console.log(data.msg)
        }
        this.collecting = false
      })
    },
    goCert(cert) {
      // 已经购买 并且已经学完 就可以查看证书了
      this.$router.push({
        path: '/personal/certification/share',
        query: {
          url: cert
        }
      })
    }
  },
  beforeDestroy() {
    // 调用接口统计播放时长
    this._browseTimeLog()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let pageId = from.meta.id
      // console.log('fromLinkId', vm.fromLinkId)
      // 页面从哪里来埋点
      // fromLinkId
      // 1: 从banner进来
      // 2: 从首页微课列表
      // 3: 大咖的微课列表
      // 4: 首页搜索
      // console.log(vm.teacherId, vm.teacherId === 'undefined')
      if (vm.fromLinkId && (vm.fromLinkId !== '3' || (vm.fromLinkId === '3' && vm.teacherId !== 'undefined'))) {
        browsePageLog(vm.courseId, vm.videoId, vm.fromLinkId)
      }
    })
  },
  components: {
    ConTab,
    Loading,
    Zhuli,
    FreeCountdown,
    GetVip,
    QrPopup
  },
  watch: {
    $route: function(route) {
      // console.log(route)
      // 播放完跳下一节课
      // 相关课程的 列表也要经过这里
      if(this.videoId !== route.params.video_id || this.courseId !== route.params.id) {
        // this.videoId = route.params.video_id
        // 刷新当前页面
        this.$router.replace({
          name: 'blank',
          params: {
            newPath: route.path
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .home{
    display flex
    width 100%
    height size(80)
    padding-left: size(30)
    padding-right: size(30)
    background-color: #333333
    color: #999999
    flex-direction row
    flex-wrap nowrap
    align-items center
    span, a{
      font-size size(28)
      width 50%
      i{
        font-size: size(40)
        margin-right: size(6)
        position relative
        top: size(2)
      }
    }
    a{
      text-align right
      i{
        font-size: size(42)
        top: size(6)
      }
    }
  }
  .player-wrapper{
    display block
    width: 100%
    // height: size(412.5)
    padding-bottom: 55%
    background-color: #000
    position relative
    overflow hidden
    // margin-top: size(80)
    >div{
      width: 100%
      height: 100%
      position absolute
      top: 0
      left: 0;
    }
    .tip-time{
      position absolute
      top size(300)
      left 0
      width 100%
      text-align center
      z-index 999
      color #fff
      -webkit-transform: translateY(-50%)
      -moz-transform: translateY(-50%)
      -ms-transform: translateY(-50%)
      -o-transform: translateY(-50%)
      transform: translateY(-50%)
    }
    .no-access{
      background-color: #aaa
      text-align center
      padding: size(30)
      font-size size(30)
      background-repeat: no-repeat
      -webkit-background-size: 100% 100%
      background-size: 100% 100%
      color #fff
    }
    .audio-poster{
      position absolute
      top: 0
      left 0
      width 100%
      height 100%
      display none
      background-repeat no-repeat
      -webkit-background-size: 100% 100%
      background-size: 100% 100%
    }
  }
  .big-title-wrap
    background #f9f8f8
    padding-bottom size(20)
  .big-title
    background #ffffff
    padding size(20) size(30) size(8)
    p
      font-size size(34)
      font-weight 700
      line-height size(52)
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 2
      -webkit-box-orient vertical
      word-wrap break-word
      word-break break-all
      span
        font-weight normal
        color #ffffff
        font-size 12px
        line-height 18px
        height 18px
        border-radius 8px
        padding 0 size(10)
        vertical-align middle
        position relative
        top -2px
        margin-right size(16)
        display inline-block
        background $color-theme
        background linear-gradient(to top right, $color-theme, lighten($color-theme, 30%))
    .price
      line-height size(72)
      .n,.f
        color #ff3125
        font-size size(36)
        font-weight 700
      .o
        font-size size(24)
        color #666
        position relative
        top size(-12)
      .f
        font-size size(34)
      .b
        font-size size(30)
        color #666
      .zan
        float right
        color #999
        font-size size(28)
        &.active
          color $color-theme
        .iconfont
          font-size 15px
    .vip-label,.vip-label-1
      display inline-block
      width size(70)
      vertical-align middle
      position relative
      top -2px
    .vip-label-1
      width size(96)
  .nav-tab{
    position relative
    z-index 7
    background-color: #fff
  }
  .nav2{
    position relative
    display table
    width 100%
    height size(90)
    padding-left: size(30)
    padding-right: size(30)
    .col{
      display table-cell
      vertical-align middle
      width 50%
    }
    .col-1{
      font-size size(34)
      text-align left
      color $color-text
    }
    .col-2{
      font-size size(28)
      text-align right
      span{
        display inline-block
        margin-left 8px
        i.shang{
          font-style normal
          font-weight 600
        }
      }
      span.active{
        color $color-theme
      }
    }
  }
  .nav2:before{
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    content: '';
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    background-color: #e6e6e6;
  }
  .buy{
    z-index 9
    position fixed
    bottom: 0
    left 0
    width: 100%
    height: size(100)
    display block
    text-align center
    background #fff
    >div{
      display table
      width 100%
      height 100%
      .col{
        display table-cell
        // width: 50%
        vertical-align middle
      }
      .col-1{
        width percentage(270/750)
        color #fff
        font-size: size(32)
        background #333
        background linear-gradient(to left, #333, alpha(#333, .8))
        .iconfont{
          font-size size(38)
          position relative
          top 2px
        }
        .icon-yishoucang{
          color $color-theme
        }
      }
      .col-2{
        font-size size(32)
        color #fff
        background-color $color-theme
        background linear-gradient(to bottom right, $color-theme, alpha($color-theme, .65))
        &.disabled{
          opacity .5
        }
      }
    }
  }
  .buy:before{
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    height: 1px;
    content: '';
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    background-color: #e6e6e6;
  }
  .dashang-dialog-wrap{
    width: 100%
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 9999
      background-color: rgba(0, 0, 0, .5)
    }
    .content{
      text-align center
      font-size size(28)
      position fixed
      top: size(450)
      left 50%
      z-index 99999
      -webkit-transform: translateX(-50%)
      -moz-transform: translateX(-50%)
      -ms-transform: translateX(-50%)
      -o-transform: translateX(-50%)
      transform: translateX(-50%)
      width size(500)
      background-color: #fff
      padding size(30)
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      .title{
        margin-bottom: size(40)
      }
      .input-wrap{
        margin-bottom: size(30)
        input{
          border: 1px solid #eee
          font-size size(26)
          width calc(100% - 2em)
          padding size(20)
          -webkit-border-radius: size(6)
          -moz-border-radius: size(6)
          border-radius: size(6)
          margin-right .4em
          appearance: none
          -webkit-appearance: none
        }
      }
      .btns{
        position: relative
        display table
        width 100%
        margin-top: size(60)
        padding-top: size(30)
        .col{
          display table-cell
          width 50%
          vertical-align middle
        }
      }
      .btns:before{
        position: absolute;
        right: size(-30);
        top: 0;
        left: size(-30);
        height: 1px;
        content: '';
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        background-color: #e6e6e6
      }
    }
  }
  .zhuan{
    position: fixed
    top size(660)
    right 0
    display block
    width 100%
    z-index 99
    >div{
      display block
      width 100%
      text-align right
      >div{
        background-color: $color-theme
        display table
        float right
        color #fff
        font-size: size(24)
        padding size(10)
        border-top-left-radius: size(40)
        border-bottom-left-radius: size(40)
        .col{
          display table-cell
          vertical-align middle
        }
        .col-1{
          .iconfont{
            font-size: size(35)
          }
        }
        .col-2{
          padding-left size(5)
        }
      }
    }
  }
  .ended-dialog-wrap{
    width: 100%
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 9999
      background-color: rgba(0, 0, 0, .5)
    }
    .content{
      text-align center
      font-size size(28)
      position fixed
      top: size(450)
      left 50%
      z-index 99999
      -webkit-transform: translateX(-50%)
      -moz-transform: translateX(-50%)
      -ms-transform: translateX(-50%)
      -o-transform: translateX(-50%)
      transform: translateX(-50%)
      width size(500)
      background-color: #fff
      padding size(30)
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      .title{
        padding-left: size(40)
        padding-right: size(40)
        line-height 1.5
      }
      .btns{
        position: relative
        display table
        width 100%
        margin-top: size(30)
        padding-top: size(30)
        .col{
          display table-cell
          width 50%
          vertical-align middle
        }
      }
      .btns:before{
        position: absolute;
        right: size(-30);
        top: 0;
        left: size(-30);
        height: 1px;
        content: '';
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        background-color: #e6e6e6
      }
    }
  }
  .pl-dialog-wrap{
    width: 100%
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 9999
      background-color: rgba(0, 0, 0, .5)
    }
    .content{
      text-align center
      font-size size(28)
      position fixed
      top: 50%
      left 50%
      z-index 99999
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      width 80%
      background-color: #fff
      padding size(30)
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      .title{
        margin-bottom: size(40)
      }
      .input-wrap{
        margin-bottom: size(30)
        textarea{
          border: 1px solid #eee
          font-size size(26)
          width 100%
          padding size(20)
          -webkit-border-radius: size(6)
          -moz-border-radius: size(6)
          border-radius: size(6)
          margin-right .4em
          appearance: none
          -webkit-appearance: none
          outline none
          height size(200)
          resize none
        }
      }
      .btns{
        position: relative
        display table
        width 100%
        margin-top: size(30)
        padding-top: size(30)
        .col{
          display table-cell
          width 50%
          vertical-align middle
        }
      }
      .btns:before{
        position: absolute;
        right: size(-30);
        top: 0;
        left: size(-30);
        height: 1px;
        content: '';
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        background-color: #e6e6e6
      }
    }
  }
  .qr-popup{
    position relative
    z-index 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/play/play.vue